import axios from 'axios'

// state
const state = {
  loading: false,
  isPasswordText: false,
  mqPhone: window.matchMedia('(max-width: 767px)'),
  lang: ''
}

// getters
const getters = {
  getLoaderState () {
    return state.loading
  },
  getIsMobile () {
    return state.mqPhone.matches
  },
  getIsPasswordForm () {
    return state.isPasswordText
  },
  getLang () {
    return state.lang
  }
}

// actions
const actions = {
  async login ({ commit }, data) {
    try {
      const response = await axios.post(process.env.BASE_URL + '/clm-admin/api/login', data, {
        headers: {
          'Authorization': ''
        }
      })
      axios.defaults.headers.common['Authorization'] = `Bearer ${sessionStorage.getItem('sessionToken')}`
      return response
    } catch (error) {
      console.log(error)
      return error
    }
  },
  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  },
  getLang ({commit}, actions) {
    commit('SET_LANG', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'SET_LANG' (state, actions) {
    state.lang = actions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js